import { Alert } from '@/global/components/Alert'

interface IProps {
    message: string
}

export default function DigitacaoErrorOverlay({ message }: IProps) {
    return (
        <div className="flex justify-center items-center h-full">
            <Alert severity="error" className="w-fit">
                {message ?? 'Erro ao carregar dados'}
            </Alert>
        </div>
    )
}
